export default __webpack_public_path__ + "static/media/kinetic-cta.a0b2d29e.svg";